import { AModel } from '../../../../api/abstracts/model.abstract';

export class GeoLocationModel extends AModel {
    public fillables: any = {
        Zip: 'Zip',
        Distance: 'Distance',
        Latitude: 'Latitude',
        Longitude: 'Longitude',

        zip: 'Zip',
        radius: 'Distance',
    };
    public defaults: any = {
        Latitude: 34.0625448,
        Longitude: -118.338469,
    }
    constructor (args) {
        super(args)
        this.init(args, this);
    }
}

export class VehicleModelModel extends AModel {
    public fillables: any = {
        Make: 'Make',
        Model: 'Model',
        Trims: 'Trims',

        vehicleMake: 'Make',
        vehicleTrim: 'Trims',
        vehicleModel: 'Model',
    };
    public defaults: any = {
    }
    constructor (args) {
        super(args)
        this.init(args, this);

        // Make Trim To Be Array - As per current implementation //
        if (!this.isCollection) {
            const trim = this.get('vehicleTrim');
            if (trim) {
                this.set('vehicleTrim', [trim]);
            }
        }
    }
}

export class VehicleModel extends AModel {
    public fillables: any = {
        vehicleMake: 'Make',
        Model: VehicleModelModel,
    };
    public defaults: any = {
    }
    constructor (args) {
        super(args)
        this.init(args, this);
        
        // Vehicle Model Setup //
        const model = new VehicleModelModel([args]);
        this.set('Model', model);
    }
}

export class RangeModel extends AModel {
    public fillables: any = {
        Min: 'Min',
        Max: 'Max',
    };
    public defaults: any = {};
    constructor (args) {
        super(args)
        this.init(args, this);
    }
    removeNonNumeric (value) {
        const values = value.toString().split('.');
        values[0] = values[0].replace(/\D/img, '');
        return values.join('.');
    }
    _MinHandler (value) {
        return this.removeNonNumeric(value);
    }
    _MaxHandler (value) {
        return this.removeNonNumeric(value);
    }
}

export class VehicleFilterModel extends AModel {
    public fillables: any = {
        Sort: 'Sort',
        DealId: 'DealId',
        QuerySize: 'QuerySize',
        IsMonthlyFilterEnabled: 'IsMonthlyFilterEnabled',

        year: 'Year',
        Terms: 'Term',
        pageSize: 'PageSize',
        pageNumber: 'PageNumber',
        vehicleStyle: 'BodyStyle',
        vehicleCondition: 'Condition',
        searchKeywords: 'SearchKeyword',
        maxDownPayment: 'MaxDownPayment',
        maxMonthlyPayment: 'MaxMonthlyPayment',

        Price: RangeModel,
        Mileage: RangeModel,
        YearRange: RangeModel,
        Vehicle: VehicleModel,
        GeoLocation: GeoLocationModel,

        // minYear: '',
        // maxYear: '',
        // minMileage: '',
        // maxMileage: '',
        maxPayment: '',
        minPayment: '',
        
        ApprovedAmount: '',
        MinimumAmountFinanced: '',
    }
    public defaults: any = {
        QuerySize: 1000,
        IsMonthlyFilterEnabled: false,
        Sort: {
            Direction: 1,
            SortBy: 'Year',
        }
    }
    constructor (args) {
        super(args)
        this.init(args, this);

        // Setup Geolocation Filter //
        const geolocation = new GeoLocationModel(args);
        this.set('GeoLocation', geolocation);

        // Setup Vehicle Model //
        const vehicle = new VehicleModel(args);
        this.set('Vehicle', vehicle);

        // Setup Ranges //
        // - Year - //
        if (this.get('minYear') && this.get('maxYear')) {
            const yearRange = new RangeModel({
                Min: this.get('minYear'),
                Max: this.get('maxYear')
            });
            this.set('YearRange', yearRange);
        } else {
            if (this.get('minYear')) this.set('year', this.get('minYear'));
            if (this.get('maxYear')) this.set('year', this.get('maxYear'));
        }
        // - Mileage - //
        if (this.get('minMileage') || this.get('maxMileage')) {
            const mileRange = new RangeModel({
                Min: this.get('minMileage'),
                Max: this.get('maxMileage')
            });
            this.set('Mileage', mileRange);
        }
        // - Price - //
        if (this.get('MinimumAmountFinanced') || this.get('ApprovedAmount')) {
            const priceRange = new RangeModel({
                Min: this.get('MinimumAmountFinanced'),
                Max: this.get('ApprovedAmount')
            });
            this.set('Price', priceRange);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auto-loans/models/vehicle-filter.model.ts